var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJivoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_606_3358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#4B291C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.537 10.236C15.273 10.236 7.76401 16.14 7.76401 23.419C7.76401 26.865 9.44801 30.008 12.206 32.356C12.101 34.646 11.626 37.723 9.94901 39.31C13.153 39.31 16.433 37.2 18.379 35.68C20.286 36.275 22.363 36.601 24.537 36.601C33.8 36.601 41.31 30.698 41.31 23.419C41.31 16.139 33.8 10.236 24.537 10.236Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0432 15.1737L29.8165 19.5726C30.0747 19.8107 30.0825 20.204 29.8339 20.4512C29.8115 20.4735 29.7873 20.4942 29.7617 20.5131L20.0444 27.6546C19.76 27.8636 19.3525 27.8123 19.1342 27.5401C19.0472 27.4315 19 27.2985 19 27.1617V20.3316C19 20.1663 19.0688 20.0078 19.1912 19.8912L24.1351 15.181C24.3854 14.9425 24.7888 14.9393 25.0432 15.1737ZM26.0428 24.348L29.1645 22.1567C29.4536 21.9538 29.8598 22.0136 30.0718 22.2903C30.1535 22.3969 30.1975 22.5256 30.1975 22.6578V27.0404C30.1975 27.3836 29.9069 27.6618 29.5484 27.6618C29.4103 27.6618 29.2758 27.6197 29.1645 27.5415L26.0428 25.3502C25.7537 25.1473 25.6912 24.7584 25.9032 24.4817C25.9424 24.4306 25.9894 24.3855 26.0428 24.348ZM25.0613 25.7762L27.1266 27.2117C27.3897 27.3946 27.4709 27.7356 27.3165 28.0096L25.2512 31.6736C25.0809 31.9756 24.6871 32.0883 24.3716 31.9254C24.2602 31.8678 24.1687 31.7803 24.1086 31.6736L22.0433 28.0096C21.8889 27.7356 21.9701 27.3946 22.2332 27.2117L24.2985 25.7762C24.5259 25.6181 24.8338 25.6181 25.0613 25.7762Z",
    stroke: "#111718",
    strokeWidth: 0.645896
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_606_3358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJivoMobile);
export default __webpack_public_path__ + "static/media/jivo_mobile.250881e3ecc8b35652cc3958bcfacdaf.svg";
export { ForwardRef as ReactComponent };